import { render, staticRenderFns } from "./Form15ProcessHeader.vue?vue&type=template&id=6c5a1cd9&scoped=true"
import script from "./Form15ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form15ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form15ProcessHeader.vue?vue&type=style&index=0&id=6c5a1cd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a1cd9",
  null
  
)

export default component.exports